import toDateTime from "./toDateTime";

/**
 * Checks if the first date is after the second one.
 *
 * @param dateA - The first date input.
 * @param dateB - The second date input.
 * @returns true if `a` is after `b`, otherwise false.
 */
const isAfter = (dateA: any, dateB: any): boolean => {
    const dateTimeA = toDateTime(dateA);
    const dateTimeB = toDateTime(dateB);

    if (!dateTimeA.isValid || !dateTimeB.isValid) {
        console.warn("Invalid date(s) passed to isAfterLuxon", { dtA: dateTimeA, dtB: dateTimeB });
        return false;
    }

    return dateTimeA.toMillis() > dateTimeB.toMillis();
};

export default isAfter;
